let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eyDcc")).then(() => parcelRequire('9iw4I'));